<template>
  <div>
    <div class="main-title">店铺信息</div>
    <div style="width: 800px; margin: 0 auto">
      <el-form :model="form" :rules="formRules" ref="form" label-width="150px">
        <a-spin :spinning="spinning">
          <el-form-item label="店铺名称" prop="shopName">
            <el-input
              v-model="form.shopName"
              :disabled="formDisabel"
              maxlength="15"
              show-word-limit
              placeholder="请输入店铺名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="经营区域" prop="areaCodes">
            <el-select :disabled="formDisabel" v-model="form.areaCodes" multiple placeholder="请选择经营区域" style="width: 100%;">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商家电话" prop="shopPhone">
            <el-input
              v-model="form.shopPhone"
              :disabled="formDisabel"
              placeholder="请输入商家电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="客服微信号" prop="shopWechat">
            <el-input
              v-model="form.shopWechat"
              :disabled="formDisabel"
              placeholder="请输入客服微信号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="所在地区"
            prop="shopAdressTown"
            v-if="!formDisabel"
          >
            <el-cascader
              style="width: 100%"
              :disabled="formDisabel"
              placeholder="请选择所在地区"
              v-model="location"
              :options="locationData"
              @change="handleChange"
            />
            <!-- <el-cascader
            ref="cascader"
            style="width: 100%"
            size="small"
            :disabled="formDisabled"
            :props="props"
            expand-trigger="click"
            :show-search="{ filter }"
            @change="handleChange"
            v-model="location"
            placeholder="请选择所在地区"
          ></el-cascader> -->
          </el-form-item>
          <el-form-item
            label="所在地区"
            prop="shopAdressTown"
            v-if="formDisabel"
          >
            <el-input
              v-model="locationStr"
              placeholder="请选择所在地区"
              :disabled="formDisabel"
            ></el-input>
          </el-form-item>
          <el-form-item label="店铺详细地址" prop="shopAdressDetail">
            <el-input
              :disabled="formDisabel"
              placeholder="请输入店铺详细地址"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 2 }"
              v-model="form.shopAdressDetail"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="店铺简介" prop="shopIntroduce">
            <el-input
              :disabled="formDisabel"
              placeholder="请输入店铺简介"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 8 }"
              v-model="form.shopIntroduce"
              maxlength="1000"
              show-word-limit
            ></el-input>
          </el-form-item>
          <div class="checked-box">
            <div>
              <el-checkbox v-model="checked" :disabled="formDisabel">
                我已同意
              </el-checkbox>
              <div
                class="checked"
                :class="formDisabel ? 'disabel' : ''"
                @click="showChecked = !formDisabel"
              >
                《商家入驻协议》
              </div>
            </div>
            <div style="text-align: right">
              <el-button
                :disabled="formDisabel"
                type="primary"
                @click="submitForm"
              >
                提交
              </el-button>
            </div>
          </div>
        </a-spin>
      </el-form>
      <el-dialog
        title="商家入驻协议"
        :visible.sync="showChecked"
        width="40%"
        :show-close="true"
        :close-on-click-modal="false"
      >
        <div>
          <iframe
            src="http://app.xhngyl.com/apk/protocol/xhnUser.html"
            frameborder="0"
            width="100%"
            height="450px"
          ></iframe>
        </div>
        <div style="text-align: right; margin-top: 30px">
          <el-button @click="showChecked = false"> 关闭 </el-button>
          <el-button type="primary" @click="showChecked = false">
            确定
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { listSearchMixin } from "../../../config/mixin";
import locationData from "@/util/locationData.js";
import api from "../../../api";
import { mapState } from "vuex";
export default {
  mixins: [listSearchMixin],
  data() {
    return {
      checked: false,
      showChecked: false,
      spinning: false,
      formDisabel: false,
      locationData,
      location: [],
      locationStr: "",
      form: {
        buyerUserId: "",
        areaCodes:[],
        shopName: "", // 店铺名称
        shopAdressProvince: "", // 省
        shopAdressCity: "", // 市
        shopAdressTown: "", // 区
        shopAdressDetail: "", // 详细地址
        shopPhone: "", //电话
        shopIntroduce: "", //简介
        shopWechat: "", // 客服微信号
        scopeId: 2 // 1-B2C 2-B2B 3-F2F
      },
      options:[
        // {
        //   value:'BASE',
        //   label:'隆阳区'
        // },
        // {
        //   value:'BS-WY',
        //   label:'瓦窑'
        // }
      ],
      formRules: {
        shopName: [
          { required: true, message: "店铺名称不能为空", trigger: "blur" },
        ],
        areaCodes: [
          { required: true, message: "请选择经营区域", trigger: "change" },
        ],
        shopAdressTown: [ //validator: this.validateAdress,
          { required: true, message: "请选择所在地区", trigger: "change" },
        ],
        shopPhone: [
          { required: true, validator: this.validatePhone, trigger: "blur" },
        ],
        shopAdressDetail: [
          {
            required: true,
            message: "店铺详细地址不能为空",
            trigger: "blur",
          },
        ],
        // shopIntroduce: [
        //   { required: true, message: "店铺简介不能为空", trigger: "blur" },
        // ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    this.form.buyerUserId = this.userInfo.buyerUserId;
    this.check();
    this.checkState();
    this.getShopAreaData();
  },
  methods: {
    getShopAreaData(){
      let params = {
        url: api.supportArea,
        method: "GET"
      };
      this.sendReq(params, (res) => {
          if (res.code == 200){
            this.options = [];
            res.data.forEach(d => {
              this.options.push({
                label: d.area,
                value: d.areaCode
              });
            })
          }
      });
    },
    checkState() {
      let params = {
        url: api.checkState,
        method: "POST",
        data: {
          buyerUserId: this.userInfo.buyerUserId,
        },
      };
      this.sendReq(params, (res) => {
        if (res.code == 200) {
          this.formDisabel = true;
          this.checked = true;

          let {
            shopName,
            areaCodes,
            shopAdressDetail,
            shopPhone,
            shopWechat,
            shopIntroduce,
            shopAdressProvince,
            shopAdressCity,
            shopAdressTown,
          } = res.data;

          this.form.shopName = shopName;
          this.locationStr =
            shopAdressProvince + "-" + shopAdressCity + "-" + shopAdressTown;
          this.form.shopAdressDetail = shopAdressDetail;
          this.form.shopPhone = shopPhone;
          this.form.shopWechat = shopWechat;
          this.form.shopIntroduce = shopIntroduce;
          this.form.areaCodes = areaCodes;
          const { checkState, shopId } = res.data;
          switch (checkState) {
            case 0:
              this.$message({
                type: "warning",
                message: "入驻申请待审核",
              });
              return;
            case 1:
              let params = {
                url: api.getShopApply,
                method: "POST",
                data: {
                  shopId,
                  scopeId: 2
                },
              }
              this.sendReq(params, (res) => {
                switch(res.data.checkHandle){
                  case 1:
                    return this.$confirm({
                      title: "欢迎入驻小黄牛供应链平台！",
                      content: (h) => {
                        return (
                          // 您的店铺入驻申请已经成功，小黄牛供应链已为您开通商户端-店铺管理权限！快到商户端进行账户认证，完成开店吧~
                          <div style="font-size:15px">
                            大宗集采业务申请已经成功，小黄牛供应链已为您开通商户端-店铺管理权限！快到商户端进行账户认证，完成开店吧~
                          </div>
                        );
                      },
                      icon: "check-circle",
                      width: 600,
                      cancelText: "我再逛逛",
                      okText: "进入商户端 ",
                      okType: "danger",
                      onOk: () => {
                        window.open("http://merchant.xhngyl.com");
                      },
                    });
                  case -1:
                    return this.$message.warning("大宗集采业务申请待审核");
                  case 0:
                    return this.$message.error("大宗集采业务申请被拒绝，请联系平台客服");
                }
              })
              return;
            case 2:
              this.$message({
                type: "error",
                message: "入驻申请已被平台拒绝，请联系平台客服",
              });
              return;
          }
        }
      });
    },
    check() {
      let params = {
        url: api.enterprisePass,
        method: "POST",
        data: {},
      };
      this.sendReq(params, (res) => {
        if (res.code !== "200") {
          this.$confirm({
            title: "机构认证",
            content: (h) => {
              return (
                <div>
                  <div style="font-size:14px;margin-bottom:10px;">
                    您当前还没有机构认证,或者未通过机构认证,
                    <span style="font-size:15px;margin-left:2px;color:#ff4d4f;">
                      需认证成功后才可以申请合作
                    </span>
                  </div>
                  <div>
                    您也可以从
                    <span style="font-size:12px;margin:0 4px;color:#999;">
                      个人中心-机构认证
                    </span>
                    进入提交认证,未认证不会影响您浏览商品
                  </div>
                </div>
              );
            },
            icon: "exclamation-circle",
            width: 600,
            cancelText: "下次再说",
            okText: "立即认证",
            okType: "danger",
            onOk: () => {
              this.$router.push({
                path: "/companyCertificate",
              });
            },
          });
          this.formDisabel = true;
        }
      });
    },
    validateAdress(rule, value, callback) {
      if (!value) {
        return callback(new Error("所在地区不能为空"));
      } else {
        callback();
      }
    },
    validatePhone(rule, value, callback) {
      let reg = /^(0|86|17951)?(1[3-9])[0-9]{9}$/;
      let res = reg.test(value);
      if (!value) {
        return callback(new Error("商家电话不能为空"));
      } else if (!res) {
        return callback(new Error("请输入正确的联系电话"));
      } else {
        callback();
      }
    },
    handleChange(arr) {
      let locationData = this.locationData;
      locationData.forEach((Province) => {
        if (Province.value == arr[0]) {
          this.form.shopAdressProvince = Province.label;

          Province.children.forEach((City) => {
            if (City.value == arr[1]) {
              this.form.shopAdressCity = City.label;

              City.children.forEach((Town) => {
                if (Town.value == arr[2]) {
                  this.form.shopAdressTown = Town.label;
                }
              });
            }
          });
        }
      });
    },
    submitForm() {
      if (!this.checked) {
        this.$message({
          message: "请同意商家入驻协议",
          type: "warning",
        });
        return;
      }
      this.spinning = true;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            url: api.shopCheck,
            data: this.form,
          };
          this.sendReq(params, (res) => {
            if (res.code == 200) {
              let { shopAdressProvince, shopAdressCity, shopAdressTown } =
                this.form;

              this.locationStr =
                shopAdressProvince +
                "-" +
                shopAdressCity +
                "-" +
                shopAdressTown;

              this.formDisabel = true;
              this.spinning = false;
              this.$message({
                message: "申请店铺成功",
                type: "success",
              });
            } else {
              this.spinning = false;
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
          });
        } else {
          this.spinning = false;
          this.$message({
            message: "请核对信息是否完善",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-title {
  font-size: 22px;
  text-align: center;
  font-weight: bold;
  color: #333333;
  margin-bottom: 42px;
  margin-top: 42px;
}
.checked-box {
  box-sizing: border-box;
  padding: 10px 220px;

  .checked {
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    color: #f77b0b !important;
    cursor: pointer;
  }

  .disabel {
    cursor: not-allowed;
    // pointer-events: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/userCenter/shopData/index.vue